import { BRAND } from "../../lib/brand";

export const Logo = ({ className = "h-14", testId = "brand-logo", eager = false }) => (
  <span className="logo-plate">
    <img
      src={BRAND.logo}
      srcSet={BRAND.logoSrcSet}
      sizes="(max-width: 640px) 160px, 300px"
      alt="BalkanPuls.de – Naši ljudi. Naše teme. Njemačka."
      width={1866}
      height={472}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`${className} w-auto select-none`}
      data-testid={testId}
    />
  </span>
);

export const BrandIcon = ({ className = "h-9 w-9", testId = "brand-icon" }) => (
  <img src={BRAND.iconSmall} alt="BalkanPuls.de" width={192} height={192} className={className} data-testid={testId} />
);

export const BrandLoader = ({ label = "Učitavanje…" }) => (
  <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3" role="status" data-testid="brand-loader">
    <BrandIcon className="h-12 w-12 animate-pulse" testId="loader-icon" />
    <span className="text-sm text-muted-foreground">{label}</span>
  </div>
);
